import { createStore } from "vuex";
// import createPersistedState from "vuex-persistedstate";
import applicant from "./modules/applicant";
import occupation from "./modules/occupation";
import family from "./modules/family";
import colleague from "./modules/colleague";

import upload from "./modules/upload";
import fetchOdooApi from "./modules/fetch_odoo_api";

// initial state
// let initialState = {
//   applicant: applicant.state,
//   occupation: occupation.state,
//   family: family.state,
//   colleague: colleague.state,
//   upload: upload.state,
//   fetchOdooApi: fetchOdooApi.state,
// };
const freshState = () => ({
  applicant: applicant.state(),
  occupation: occupation.state(),
  family: family.state(),
  colleague: colleague.state(),
  upload: upload.state(),
  fetchOdooApi: fetchOdooApi.state(),
});

const store = createStore({
  modules: {
    applicant,
    occupation,
    family,
    colleague,
    upload,
    fetchOdooApi,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {
    reset(state) {
      console.log("Resetting state...");
      const fresh = freshState();
      Object.keys(fresh).forEach((key) => {
        state[key] = fresh[key];
      });
    },
  },
  plugins: [
    // createPersistedState({
    //   reducer: (state) => {
    //     const { upload, ...rest } = state;
    //     console.log(upload);
    //     return rest;
    //   },
    // }),
  ],
});

export default store;
